import React, {Component} from 'react'
import {Image, Grid, Row, Col} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

import josieImage from './josie-ide.jpg'

import './index.css'

class About extends Component {
  render() {
    var email = 'contact@josieide.com'

    return (
      <section id={this.props.id}>
        <div className='container'>
          <h2>About</h2>
          <Grid>
            <Row className='show-grid'>
              <Col xs={12} md={4} mdOffset={2}>
                <Image src={josieImage} circle responsive className='josie' />
                <ul className='list-inline social-buttons'>
                  <li>
                    <a href={`mailto:${email}?Subject=Facial%20Reconstruction`} target='_blank'>
                      <FontAwesome name='envelope'/>
                    </a>
                  </li>
                  <li>
                    <a href='https://uk.linkedin.com/in/josieide' target='_blank'>
                      <FontAwesome name='linkedin'/>
                    </a>
                  </li>
                  <li>
                    <a href='https://medium.com/@josie_ide' target='_blank'>
                      <FontAwesome name='medium'/>
                    </a>
                  </li>
                  <li>
                    <a href='https://twitter.com/josie_ide' target='_blank'>
                      <FontAwesome name='twitter'/>
                    </a>
                  </li>
                </ul>
                <br />
              </Col>
              <Col xs={12} md={4}>
                <p>
                  A forensic artist with a special interest in facial reconstruction currently based in Dundee.
                </p>
                <p>
                  Josie is a graduate of the Forensic Facial Identification MSc course at the University of Dundee and previously achieved a First class hons. degree in Bioarchaeology from the University of Bradford.
                </p>
                <p>
                  Applying her anatomical and osteological understanding to the interpretation of human skulls Josie creates accurate 3D and 2D facial reconstructions. The methods often utilise software such as Adobe Photoshop, Illustrator and Geomagic Freeform 3D.
                </p>
                <p>
                  Josie currently has some of her work on display until October 2017 in the Edinburgh Alphabet Exhibition at the City Arts Centre, Edinburgh. Her recent projects have included 2D colour photoshop facial reconstructions from archaeological skulls and clay 3D facial reconstruction models. She is currently working on two journal articles related to facial reconstruction and osteology which will be published in the near future.
                </p>
              </Col>
            </Row>
          </Grid>
      </div>
    </section>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/App/About/index.js